
import { Card } from '@/components/ui/card';
import { ProductProvider } from '@/context/ProductContext';
import ProductHeader from './products/ProductHeader';
import ProductContent from './products/ProductContent';
import ProductDialogs from './products/ProductDialogs';
import { toast } from 'sonner';
import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Loader2 } from 'lucide-react';

export default function ProductManagement() {
  const [isConnecting, setIsConnecting] = useState(true);
  const [connectionError, setConnectionError] = useState(false);

  // Vérifie la connexion à Supabase au montage
  useEffect(() => {
    const checkSupabaseConnection = async () => {
      try {
        setIsConnecting(true);
        const { error } = await supabase
          .from('products')
          .select('*', { count: 'exact', head: true });

        if (error) {
          console.error('Erreur de connexion Supabase :', error);
          toast.error("Problème de connexion à la base de données. Certaines fonctionnalités peuvent ne pas fonctionner correctement.");
          setConnectionError(true);
        } else {
          setConnectionError(false);
          // Connection successful
          toast.success("Connexion à la base de données établie");
        }
      } catch (err) {
        console.error('Échec de la vérification de la connexion à Supabase :', err);
        toast.error("Impossible de vérifier la connexion à Supabase");
        setConnectionError(true);
      } finally {
        setIsConnecting(false);
      }
    };

    checkSupabaseConnection();
  }, []);

  const reconnectToSupabase = async () => {
    await checkSupabaseConnection();
  };

  const checkSupabaseConnection = async () => {
    try {
      setIsConnecting(true);
      const { error } = await supabase
        .from('products')
        .select('*', { count: 'exact', head: true });

      if (error) {
        console.error('Erreur de connexion Supabase :', error);
        toast.error("Problème de connexion à la base de données. Certaines fonctionnalités peuvent ne pas fonctionner correctement.");
        setConnectionError(true);
      } else {
        setConnectionError(false);
        toast.success("Connexion à la base de données établie");
      }
    } catch (err) {
      console.error('Échec de la vérification de la connexion à Supabase :', err);
      toast.error("Impossible de vérifier la connexion à Supabase");
      setConnectionError(true);
    } finally {
      setIsConnecting(false);
    }
  };

  if (isConnecting) {
    return (
      <Card className="flex justify-center items-center p-10">
        <div className="flex flex-col items-center space-y-4">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p>Vérification de la connexion à la base de données...</p>
        </div>
      </Card>
    );
  }

  if (connectionError) {
    return (
      <Card className="p-6">
        <div className="text-center space-y-4">
          <h3 className="text-xl font-bold text-destructive">Problème de connexion à la base de données</h3>
          <p>Impossible de se connecter à la base de données Supabase. Veuillez vérifier votre connexion internet et les identifiants Supabase.</p>
          <button
            onClick={reconnectToSupabase}
            className="px-4 py-2 bg-primary text-white rounded hover:bg-primary/90 transition-colors"
          >
            Réessayer la connexion
          </button>
        </div>
      </Card>
    );
  }

  return (
    <ProductProvider>
      <Card>
        <ProductHeader />
        <ProductContent />
        <ProductDialogs />
      </Card>
    </ProductProvider>
  );
}
